import { reducer, RegisteredReducer } from '@ardoq/rxbeach';
import { fetchedOrgUsersSuccess, fetchOrgUsersError } from './actions';
import { OrgUsersStreamShape } from './types';
import { APIOrganizationUser } from '@ardoq/api-types';
import { setStateProperty, toByIdDictionary } from '@ardoq/common-helpers';

const fetchedOrgUsersSuccessReducer = (
  state: OrgUsersStreamShape,
  payload: APIOrganizationUser[]
): OrgUsersStreamShape => {
  return {
    ...state,
    users: payload,
    byId: toByIdDictionary(payload),
    error: null,
  };
};

export const reducers: RegisteredReducer<OrgUsersStreamShape>[] = [
  reducer(fetchedOrgUsersSuccess, fetchedOrgUsersSuccessReducer),
  reducer(fetchOrgUsersError, setStateProperty('error')),
];
